module.exports = __webpack_public_path__ + "static/SignatureCollection-2926514e5bae015aa0bbd9856f396da2.otf";